import React from 'react';
import { TMarkerType } from '@awtg-ltd/react-map-component/dist/constants/common';

import { TAsset } from '@interfaces/assets/asset';
import { ICoords, ISiteMarker } from '@interfaces/map/map';

import { EDataType } from '@enums/map';

import AssetLocationChangeView from './AssetLocationChangeView';
import SiteLocationChangeView from './SiteLocationChangeView';

interface ILocationChangeViewProps {
	asset: TAsset | null;
	markerType: TMarkerType | null;
	newCoords?: ICoords;
	reset: () => void;
	site: ISiteMarker | null;
}

const LocationChangeView = ({
	asset,
	markerType,
	newCoords,
	reset,
	site,
}: ILocationChangeViewProps) => {
	const isAssetsMode = markerType === EDataType.assets;
	const isSitesMode = markerType === EDataType.sites;

	return asset && isAssetsMode ? (
		<AssetLocationChangeView
			asset={asset}
			newCoords={newCoords}
			reset={reset}
		/>
	) : site && isSitesMode ? (
		<SiteLocationChangeView
			newCoords={newCoords}
			reset={reset}
			site={site}
		/>
	) : null;
};

export default LocationChangeView;
